import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  containerFooter: {
    backgroundColor: '#929fa0',
    padding: '4em 0 1em em 0',
    color: 'white',
  },
  containerLink: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-around',
  },
  containerList: {
    textAlign: 'right',
    margin: 'auto',
  },
  list: {
    display: 'flex',
    flexFlow: 'row wrap',
    '&:hover': {
      cursor: 'pointer',
      color: 'lightgrey',
    },
    '&:visited': {
      color: 'white',
      '&:hover': {
        cursor: 'pointer',
        color: 'lightgrey',
      },
    },
  },
  versionText: {
    margin: '3em auto 0 auto',
  },
  [theme.breakpoints.down(760)]: {
    containerLink: {
      display: 'inline',
      margin: 'auto',
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.containerFooter}>
      <div className={classes.containerLink}>
        <ul>
          <Typography variant="body1">Réseaux Sociaux:</Typography>
          <ul className={classes.containerList}>
            <Typography variant="body2" className={classes.list}>
              <a
                className={classes.list}
                href="https://www.facebook.com/La-chatterie-Le-domaine-de-Romy-106744908416602"
              >
                Facebook
              </a>
            </Typography>
            <a className={classes.list} href="https://www.instagram.com/ritzenthaler77/">
              Instagram
            </a>
          </ul>
        </ul>
        <ul>
          <Typography variant="body1">Liens utiles:</Typography>
          <ul className={classes.containerList}>
            <Typography variant="body2" className={classes.list}>
              <a className={classes.list} href="https://www.assuropoil.fr/chat/comportement/">
                Comprendre les comportements
              </a>
            </Typography>
            <Typography variant="body2" className={classes.list}>
              <a className={classes.list} href="https://maisonmoulin.fr/fr/11-recettes-pour-chats">
                Maison Moulin (nourriture pour chats)
              </a>
            </Typography>
            <Typography variant="body2" className={classes.list}>
              <a className={classes.list} href=">https://www.loof.asso.fr/actus/actus_loof.php">
                Le loof
              </a>
            </Typography>
          </ul>
        </ul>
      </div>
      <div className={classes.versionText}>
        <Typography variant="body2">Version 1-1-0 ~ © Corinne et Audrey Ritzenthaler</Typography>
      </div>
    </div>
  );
};

export default Footer;
